/** Notifications: icons, groups and tab → query params (pure, no React). */

// type → [Bootstrap icon, tone]
export const TYPE_ICONS = {
  DTR_TO_APPROVE: ["bi-calendar2-check", "blue"],
  DTR_APPROVED: ["bi-calendar2-check-fill", "green"],
  DTR_RETURNED: ["bi-arrow-return-left", "amber"],
  LEAVE_TO_APPROVE: ["bi-calendar-event", "blue"],
  LEAVE_APPROVED: ["bi-calendar-check-fill", "green"],
  LEAVE_REJECTED: ["bi-calendar-x", "red"],
  OVERTIME_TO_APPROVE: ["bi-clock-history", "blue"],
  OVERTIME_APPROVED: ["bi-clock-fill", "green"],
  OVERTIME_REJECTED: ["bi-clock", "red"],
  CHECKIN_TO_VALIDATE: ["bi-patch-question", "blue"],
  CHECKIN_REJECTED: ["bi-geo-alt", "red"],
  CORRECTION_TO_APPROVE: ["bi-pencil-square", "blue"],
  CORRECTION_APPROVED: ["bi-pencil-fill", "green"],
  CORRECTION_REJECTED: ["bi-pencil", "red"],
  PROBATION_3M: ["bi-hourglass-split", "amber"],
  PROBATION_4M: ["bi-hourglass-split", "amber"],
  PROBATION_5M: ["bi-hourglass-split", "amber"],
  PROBATION_6M: ["bi-hourglass-bottom", "amber"],
};

export const GROUPS = {
  Approvals: ["bi-check2-square", "blue"],
  Results: ["bi-clipboard-check", "green"],
  "HR alerts": ["bi-exclamation-diamond", "amber"],
};

/** The row's icon: its type's, else its group's, else a generic one. */
export const iconFor = (n) =>
  TYPE_ICONS[n?.type] || GROUPS[n?.group] || ["bi-info-circle", "gray"];

export const TABS = [
  { key: "all", label: "All" },
  { key: "unread", label: "Unread" },
  { key: "Approvals", label: "Approvals" },
  { key: "Results", label: "Results" },
  { key: "HR alerts", label: "HR alerts" },
];

/** Tab + filters → GET /notifications params. */
export const listParams = ({ tab, search, from, to, page, limit }) => ({
  page,
  limit,
  unreadOnly: tab === "unread" ? true : undefined,
  group: GROUPS[tab] ? tab : undefined,
  search: search || undefined,
  from: from || undefined,
  to: to || undefined,
});

export const emptyText = (tab, filtered) => {
  if (filtered) return "No notifications match these filters.";
  if (tab === "unread") return "You're all caught up: nothing unread.";
  if (GROUPS[tab]) return `No ${tab.toLowerCase()} notifications.`;
  return "No notifications yet.";
};
